// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 14.5V2.95',
  'M3 2.95C4.3 1.55 5.75 1.6 7.1 2.8C8.8 4.31 10.42 4.43 12.92 2.68C13.23 2.46 13.65 2.69 13.61 3.09C13.4 4.75 12.72 6.22 13.24 8.67C13.34 9.13 13.24 9.3 12.88 9.55C10.6 11.16 8.63 11.25 6.98 9.77C5.61 8.53 4.21 8.57 3 10.4',
];
